<i18n lang="yaml">
en:
  receipt_text: 'Subscription to accesshub.ru'
  pricing_plans: Pricing plans
  subscribe: Subscribe
  current_plan: Current plan
  month: month
  up_to_message: 'Up to {max_servers} servers'
  cannot_subscribe: 'Registered more servers than allowed by this plan'
ru:
  receipt_text: 'Подписка на ежемесячный доступ к сайту accesshub.ru'
  pricing_plans: Тарифные планы
  subscribe: Подписаться
  current_plan: Текущий план
  month: месяц
  up_to_message: 'До {max_servers} серверов'
  cannot_subscribe: 'Зарегистрировано больше серверов, чем позволяет этот план'
</i18n>

<script setup lang="ts">
import { useAllStores } from '@/store'
import { useMyFetch } from '@/utils'
import { handleError } from '@/utils/errors'
import { pricing_text } from '@/utils/pricing'

const { t, route, router, authStore, alertStore } = useAllStores()

const organizationId = `${route.params.organization_id}`
const { data: billingData, error } = await useMyFetch(
  `organizations/${organizationId}/plans`
).json()
await handleError(error, router, authStore, alertStore)
const publicId = billingData.value.public_id
const data = billingData.value.plans || []
console.log(publicId, data)

function pay(amount: number, currency: string, planId: String) {
  const widget = new cp.CloudPayments()
  const receipt = {
    Items: [
      {
        label: t('receipt_text'),
        price: amount,
        quantity: 1.0,
        amount: amount,
        vat: 0,
        method: 0, // тег-1214 признак способа расчета - признак способа расчета
        object: 0 // тег-1212 признак предмета расчета - признак предмета товара, работы, услуги, платежа, выплаты, иного предмета расчета
      }
    ],
    email: authStore.user.email,
    phone: '',
    isBso: false,
    amounts: {
      electronic: amount,
      advancePayment: 0.0,
      credit: 0.0,
      provision: 0.0
    }
  }

  const data = {
    CloudPayments: {
      CustomerReceipt: receipt,
      recurrent: {
        interval: 'Month',
        period: 1,
        customerReceipt: receipt
      }
    },
    AccessHub: {
      organization_id: organizationId,
      plan_id: planId
    }
  }

  widget.charge(
    {
      publicId: publicId,
      description: t('receipt_text'),
      amount: amount,
      currency: currency,
      accountId: organizationId,
      email: authStore.user.email,
      data: data
    },
    async function (options: any) {
      // success
      await router.push({ name: 'organizations:billing', params: { id: organizationId } })
    },
    function (reason: any, options: any) {
      // fail
      console.log('error', reason, options)
    }
  )
}
</script>

<template>
  <h1>{{ t('pricing_plans') }}</h1>

  <div class="row">
    <div class="col" v-for="plan in data" :key="plan.id">
      <div
        class="card h-100"
        :class="{
          'border-primary border-2': plan.is_active,
          'border-danger border-1': !plan.can_subscribe
        }"
      >
        <div class="card-body">
          <h5 class="card-title">
            <code>{{ plan.name }}</code>
          </h5>
          <h6 class="card-title">{{ pricing_text(plan, t('month')) }}</h6>
          <p class="card-text">{{ t('up_to_message', { max_servers: plan.max_servers }) }}</p>
          <a
            href="#"
            @click="pay(plan.price, plan.currency, plan.id)"
            :class="{ 'visually-hidden': plan.is_active || !plan.can_subscribe }"
            class="btn btn-primary"
            >{{ t('subscribe') }}</a
          >
          <p v-if="!plan.can_subscribe" class="card-text mt-2">ⓘ {{ t('cannot_subscribe') }}</p>
          <p v-if="plan.is_active" class="card-text mt-2">ⓘ {{ t('current_plan') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card {
  background: #fff;
  transition:
    0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
  padding: 14px 14px 14px 14px;
  cursor: pointer;
}

.card:hover {
  transform: scale(1.01);
  box-shadow:
    0 10px 20px rgba(0, 0, 0, 0.12),
    0 4px 8px rgba(0, 0, 0, 0.06);
}
</style>
